import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import UnstyledHeading from '@components/shared/unstyled-heading';

import { getConfig, getPublicConfig } from '@components/config/selectors';

import styles from './top-bar.scss';

const TopBar = () => {
  const { dataType } = useParams();
  const { cityName, publicLogo, publicLogoLink } = useSelector(getConfig);
  const { details } = useSelector(getPublicConfig);
  const title = details?.[dataType]?.form.title.label;
  return (
    <div className={styles.container}>
      {
        publicLogo &&
        <Fragment>
          {publicLogoLink ?
            <a href={publicLogoLink} rel="noopener noreferrer" target="_blank">
              <img src={publicLogo} className={styles.logo} alt={cityName} />
            </a> :
            <img src={publicLogo} className={styles.logo} alt={cityName} />
          }
          <span className={styles.separator} />
        </Fragment>
      }
      <UnstyledHeading rank={2} className={styles.entityType}>{title}</UnstyledHeading>
    </div>
  );
};

export default TopBar;
